import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import * as myGlobals from "src/app/api-module/services/globalPath";
import { BehaviorSubject, Observable } from "rxjs";
import { StaticConfigurationsEnum } from "../models/configurations-models/configurations.enums";

@Injectable({
  providedIn: 'root'
})

export class AuthConfigurationService {
  private key: Observable<any>;

  constructor(
    private http: HttpClient,
  ) { }

    // get AllConfigurations(){
    //   if (!this.key){
    //     this.key = this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.GetAllConfigurationsSettings);
    //   }
    //   return this.key;
    // }


    private _configurations = new BehaviorSubject<any | null>(null);
    private _apiCalled = false; // Prevent multiple API calls
  
   
  
    get AllConfigurationsUpdated(): Observable<any> {
      if (!this._apiCalled) {  // 🚀 Ensure API is only called once
        this._apiCalled = true;
        this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.GetAllConfigurationsSettings).subscribe(
          (data) => {
            this._configurations.next(data);
          }
        );
      }
      return this._configurations.asObservable();
    }
  
  
  
  IsConfigEnabled(configKey: StaticConfigurationsEnum): Observable<boolean> {

    return new Observable(x => {
      let IsConfigGranted = false;
      this.AllConfigurationsUpdated.subscribe(
        (res: any) => {
          if (res?.data) {
            localStorage.setItem('QuotationConfiguration', JSON.stringify(res.data));
            let configurationList = res.data;
            if (configurationList) {
              configurationList.forEach(configSetting => {
                if (configSetting.id == configKey && configSetting.value === true) {
                  IsConfigGranted = true;
                }
              });
              x.next(IsConfigGranted);
            }
            else {
              x.next(false);
            }
          }
          else {
            x.next(false);
          }
        },
        error => {
          x.next(false);

        });
    }
    );

  }


}